/**
 * GENERATED_ASSET — the three canonical batch005 recipes (`domestic-window/recipes/assets.json`, identical to the
 * docs catalog `asset-recipes.json` rows). Deep-frozen; callers pass an edited copy instead of mutating these.
 */
import type { CushionRecipe, CupPairRecipe, TideWindowRecipe } from './types';
import { deepFreeze } from './freeze';

export const HUSH_DOMESTIC_RECIPES: Readonly<{ cushion: CushionRecipe; cups: CupPairRecipe; tideWindow: TideWindowRecipe }> = deepFreeze({
  cushion: {
    "schema": "hush.asset-recipe.v1",
    "id": "hush.cushion.patched.v1",
    "assetId": "prop.hush.cushion_roll",
    "generatorId": "hush.cushion.v1",
    "seed": 20067018,
    "paletteId": "nook_warm",
    "detail": "standard",
    "params": {
      "width": 100,
      "height": 28,
      "squash": 0.84,
      "patch": "small-square",
      "patchSide": "left",
      "seamPitch": 9
    }
  },
  cups: {
    "schema": "hush.asset-recipe.v1",
    "id": "hush.cups.pair.v1",
    "assetId": "prop.hush.mismatched_cups",
    "generatorId": "hush.cups.v1",
    "seed": 20067018,
    "paletteId": "nook_warm",
    "detail": "standard",
    "params": {
      "pairSpacing": 28,
      "leftKind": "broad-handled",
      "rightKind": "slim-chipped",
      "surface": "clay",
      "scaleRatio": 0.8
    }
  },
  tideWindow: {
    "schema": "hush.asset-recipe.v1",
    "id": "hush.tide_window.quiet.v1",
    "assetId": "backdrop.hush.tide_window",
    "generatorId": "hush.tide_window.v1",
    "seed": 20067018,
    "paletteId": "nook_warm",
    "detail": "standard",
    "params": {
      "width": 330,
      "height": 160,
      "bandCount": 3,
      "waveAmplitude": 4,
      "roughEdge": 0.45,
      "depthContrast": 0.35,
      "motionMode": "static"
    }
  }
} as const);
